export default "__VITE_ASSET__BR_kjDj3__"